import { createContext } from "react";
import { EMAIL_REGEX, URL_REGEX } from "../../../../utils/useForm";

export const validateYard = (values) => {
  let errors = {};
  if (!values.firstName || values.firstName.trim().length === 0)
    errors.firstName = "First name is required";
  if (!values.lastName || values.lastName.trim().length === 0)
    errors.lastName = "Last name is required";
  if (!values.userPhone || values.userPhone.trim().length === 0)
    errors.userPhone = "User phone is required";
  if (!values.businessName || values.businessName.trim().length === 0)
    errors.businessName = "Business name is required";
  if (!values.phoneNumber || values.phoneNumber.trim().length === 0)
    errors.phoneNumber = "Phone number is required";
  if (!values.email) errors.email = "Email is required";
  else if (!EMAIL_REGEX.test(values.email)) errors.email = "Invalid email";
  if (values.website && !URL_REGEX.test(values.website))
    errors.website = "Invalid URL";
  if (!values.street || values.street.trim().length === 0)
    errors.street = "Street name is required";
  if (!values.city || values.city.trim().length === 0)
    errors.city = "City is required";
  if (!values.state || values.state.trim().length === 0)
    errors.state = "State is required";
  if (!values.zip || values.zip.trim().length === 0)
    errors.zip = "Zip code is required";
  if (!values.country || values.country.trim().length === 0)
    errors.country = "Country is required";
  if (!values.lotCapacityAcres)
    errors.lotCapacityAcres = "Yard capacity is required";
  else if (isNaN(values.lotCapacityAcres) || values.lotCapacityAcres < 0)
    errors.lotCapacityAcres = "Invalid Yard capacity";
  if (values.trackCapacity && isNaN(values.trackCapacity))
    errors.trackCapacity = "Invalid track capacity";
  if (!values.warehouseCapacity)
    errors.warehouseCapacity = "Warehouse capacity is required";
  else if (isNaN(values.warehouseCapacity) || values.warehouseCapacity < 0)
    errors.warehouseCapacity = "Invalid Warehouse capacity";
  return errors;
};

const validateCommodities = (values) => {
  return {};
};

export const validateSubscription = (values) => {
  let errors = {};
  debugger;
  if (!values.trialPeriod) errors.trialPeriod = "Trial Period is required";
  else if (isNaN(values.trialPeriod) || values.trialPeriod < 0)
    errors.trialPeriod = "Invalid Trial Period";
  if (!values.productId || values.productId.trim().length === 0)
    errors.productId = "Product is required";
  return errors;
};

export const initState = {
  yardInfo: {
    accessToRailHighway: [],
  },
  commodities: [],
  capabilities: [],
  forkLiftMaxCapacity: null,
  areas: [],
  zones: [],
  validators: [validateYard, validateCommodities, validateSubscription],
  errors: {},
  note: "",
  tosAccept: {},
  subscription: {
    customerId: "",
    productId: "",
    priceList: [],
    trialPeriod: "",
  },
  activeStep: 0,
};

export default createContext(initState);
